
export const mod = (m, n) => ((m%n)+n)%n;
